(() => {
  const selector = '.template-page .faq-accordion dt .accordion__button';
  const plus = 'M95,48H52V5a2,2,0,0,0-4,0V48H5a2,2,0,0,0,0,4H48V95a2,2,0,0,0,4,0V52H95a2,2,0,0,0,0-4Z';
  const minus = 'M94,52H4a2,2,0,0,1,0-4H94a2,2,0,0,1,0,4Z';

  function getPanel(button) {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    return panel && button.closest('.faq-accordion').contains(panel) ? panel : null;
  }

  function setState(button, panel, expanded) {
    button.setAttribute('aria-expanded', String(expanded));
    panel.setAttribute('aria-hidden', String(!expanded));
    const icon = button.querySelector('.toggle-btn');
    if (icon) {
      icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" aria-hidden="true"><path d="${expanded ? minus : plus}"></path></svg>`;
    }
  }

  function initialize(root = document) {
    root.querySelectorAll(selector).forEach(button => {
      const panel = getPanel(button);
      if (!panel) return;
      if (button.tagName !== 'BUTTON') {
        button.setAttribute('role', 'button');
        button.setAttribute('tabindex', '0');
      }
      setState(button, panel, !$(panel).is(':hidden'));
    });
  }

  function toggle(button) {
    const panel = getPanel(button);
    if (!panel) return;
    const expanded = button.getAttribute('aria-expanded') !== 'true';
    const $panel = $(panel).stop(true, true);
    setState(button, panel, expanded);
    const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 400;
    if (expanded) $panel.slideDown(duration);
    else $panel.slideUp(duration);
  }

  document.addEventListener('click', event => {
    const button = event.target.closest(selector);
    if (!button) return;
    event.preventDefault();
    toggle(button);
  });
  document.addEventListener('keydown', event => {
    const button = event.target.closest(selector);
    if (!button || button.tagName === 'BUTTON' || !['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    if (!event.repeat) toggle(button);
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
})();
